import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const ButtonGray = styled(Button)({
  backgroundColor: "#E6E4E9",
  color: "#2b2b2b",
  fontSize: "14px",
  fontWeight: "600",
  padding: "0 16px",
  textTransform: "capitalize",
  borderRadius: "10px",
  minWidth: "0px !important",
  width: "fit-content",
  height: "38px",
  "&:hover": {
    backgroundColor: "#E6E4E9",
  },
});

export default ButtonGray;
